<template>
    <el-row>
        <div class="p-3 container">
            <i class="el-icon-warning-outline mr-1"></i>
            <span>
                <b>HubSpot Workflow > Send a text (SMS/MMS)</b> action's usage is considered <b>automated</b> and <b>paid</b>. You are agreeing to our billing terms by using the action in HubSpot.
            </span>
            <a  href="https://support.aloware.com/en/articles/9033804-aloware-pricing-plans-empowering-your-teams-with-flexible-solutions"
                class="text-bluish _600"
                target="_blank">Learn more.
            </a>
            <p v-if="showCallingNote" class="mt-2 mb-0">
                <b>NOTE:</b> HubSpot authentication is required to activate the Aloware Calling for HubSpot add-on.
            </p>
        </div>
    </el-row>
</template>

<script>
export default {
    props: {
        showCallingNote: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped>
.container {
    border: 1px solid grey;
    border-radius: 5px;
    width: 100%;
    max-width: 100%;
}
</style>
